// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HomeTwoToneSvg from "@fishx/icons-svg/es/asn/HomeTwoTone";
import FishxIcon from '../components/FishxIcon';

var HomeTwoTone = function HomeTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HomeTwoToneSvg
  }));
};

HomeTwoTone.displayName = 'HomeTwoTone';
export default React.forwardRef(HomeTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HomeTwoTone.js
// module id = 2933
// module chunks = 0